import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction,
} from "mobx";
import type { BaseModel, BaseModelData } from "./BaseModel";
import type { Stores } from "./stores";

export class BaseItemStore<T extends BaseModel<BaseModelData>> {
  constructor(protected stores: Stores) {
    makeObservable(this);
  }

  @observable byId = observable.map<string, T>();
  @observable isLoaded = false;

  @action load(data: T[]) {
    // log.network("load data ", data);

    if (data) {
      runInAction(() => {
        data.forEach((it) => {
          const item = this.byId.get(it.uid);
          if (item) {
            Object.assign(item.data, it.data);
          } else {
            this.byId.set(it.uid, it);
          }
        });
      });
    }
    this.isLoaded = true;
  }

  @action deleteItem(uid: string) {
    this.byId.delete(uid);
  }

  @computed get all() {
    return Array.from(this.byId.values());
  }

  @computed get size() {
    return this.byId.size;
  }
}
